import React from 'react';
import { SvgType } from '../svgType';

export default ({ className }: SvgType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="11.994"
    height="9.854"
    viewBox="0 0 11.994 9.854"
    className={className}
  >
    <g id="noun_update_2346500" transform="translate(-26.078 -26.433)">
      <g transform="translate(26.078 26.433)">
        <path
          d="M49.012,40.733,42.4,47.34l-2.14-2.14L38.8,46.662l3.925,3.925,8.069-8.07Z"
          transform="translate(-38.801 -40.733)"
          fill="#fff"
        />
      </g>
    </g>
  </svg>
);
